import { render, staticRenderFns } from "./DatePickerRangeArea.vue?vue&type=template&id=53545d1b&scoped=true&"
import script from "./DatePickerRangeArea.vue?vue&type=script&lang=ts&"
export * from "./DatePickerRangeArea.vue?vue&type=script&lang=ts&"
import style0 from "./DatePickerRangeArea.vue?vue&type=style&index=0&id=53545d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53545d1b",
  null
  
)

export default component.exports